import React from 'react';
import { useRouteMatch, Switch } from 'react-router-dom';
import { useIntl } from 'react-intl';
import Route from '../common/Route';
import RestorePasswordRoute from './RestorePasswordRoute';
import RestoreSentRoute from './RestoreSentRoute';
import ChangePasswordRoute from './ChangePasswordRoute';
import NewPasswordRoute from './NewPasswordRoute';
import SetPasswordRoute from './SetPasswordRoute';

const PasswordRoutes = () => {
  const { path } = useRouteMatch();

  const intl = useIntl();

  return (
    <Switch>
      <Route
        exact
        path={`${path}/restore`}
        title={intl.formatMessage({
          id: 'restorePassword.seo.title',
          defaultMessage: 'ClearVPN | Restore password',
          description: 'SEO title of the usual reset password page',
        })}
      >
        <RestorePasswordRoute />
      </Route>

      <Route
        exact
        path={`${path}/restore/sent`}
        title={intl.formatMessage({
          id: 'restorePasswordSent.seo.title',
          defaultMessage: 'ClearVPN | Restore sent',
          description: 'SEO title of the page informing user that reset password email has been sent',
        })}
      >
        <RestoreSentRoute />
      </Route>

      <Route
        exact
        path={`${path}/change`}
        title={intl.formatMessage({
          id: 'changePassword.seo.title',
          defaultMessage: 'ClearVPN | Change password',
          description: 'SEO title of the page where user can change their current password',
        })}
      >
        <ChangePasswordRoute />
      </Route>

      <Route
        exact
        path={`${path}/new`}
        title={intl.formatMessage({
          id: 'setNewPassword.seo.title',
          defaultMessage: 'ClearVPN | Set new password',
          description: 'SEO title of the page sent to user on password reset request',
        })}
      >
        <NewPasswordRoute />
      </Route>

      <Route
        exact
        path={`${path}/set`}
        title={intl.formatMessage({
          id: 'setPassword.seo.title',
          defaultMessage: 'ClearVPN | Set password',
          description: 'SEO title of the page user gets onto after starting the sign up process elsewhere',
        })}
      >
        <SetPasswordRoute />
      </Route>
    </Switch>
  );
};

export default PasswordRoutes;
